import * as STD from '@emersya/mpa-std-lib';

// import * as MPAApplication     from '@libs/MPAApplication/index';
import CM                           from '@emersya/mpa-components-manager-lib';
import { Input, Link, Image, Text } from '@emersya/mpa-components-lib';

export interface IReplayLinkModalComponentValue {
};

export interface IReplayLinkModalComponentConfiguration extends Input.Configuration<
	IReplayLinkModalComponentValue,
	IReplayLinkModalComponentValue
>
{
};

export class ReplayLinkModalComponent extends Input.Component<
	HTMLDivElement,
	IReplayLinkModalComponentValue,
	IReplayLinkModalComponentValue,
	ReplayLinkModalComponent,
	IReplayLinkModalComponentConfiguration
>
{
	component_DOM : HTMLDivElement;

	override async component_start(ev : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(ev);
	};

	override isValueTheDefault() {
		return (!!(
			this.value &&
			this.defaultValue &&
			STD.object.hasSameContentDeeply(this.value, this.defaultValue)
		));
	};

	override deserialize(x : IReplayLinkModalComponentValue) {
		return (<IReplayLinkModalComponentValue> <any> x);
	};

	async reset() {
		//do nothing because this need to be more thinked.
	};

	async use(replay : string) {
		const link = <Link.Component> this.component_find('@:replayLinkContainer.replay');
		link.updateHref(replay);
		link.updateText(replay);
		const textCopy = <Text.Component> this.component_find('@:replayLinkContainer.copyText');
		textCopy.component_DOM.classList.remove('copied');
		const container = this.component_parent?.component_parent;
		if (!container) {
			this.component_throwLibraryError('');
		}
		if (container.component_isDisabled) {
			await container.component_enable();
		}
		if (this.component_isDisabled) {
			await this.component_enable();
		}
	};

	async copy() {
		const link = <Link.Component> this.component_find('@:replayLinkContainer.replay');
		if (!link.component_DOM.href) {
			return;
		}
		await navigator.clipboard.writeText(link.component_DOM.href);
		const textCopy = <Text.Component> this.component_find('@:replayLinkContainer.copyText');
		textCopy.component_DOM.classList.add('copied');
	}

	async close() {
		const container = this.component_parent?.component_parent;
		if (!container) {
			this.component_throwLibraryError('');
		}
		if (!this.component_isDisabled) {
			await this.component_disable();
		}
		if (!container.component_isDisabled) {
			await container.component_disable();
		}
	};

	serialize() {
		return {}; // Hmm why this component is an input???!
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IReplayLinkModalComponentConfiguration
	)
	{
		const tr = STD.translationsManager.languages.reduce<Record<string, string>>((a, c) => {
			a[ c ] = 'iconCopy';
			return a;
		}, {});
		configuration[ '@innerConfigurations' ] = {
			replayLinkContainer : {
				'@innerConfigurations' : {
					copyButton : {
						'@innerConfigurations' : {
							iconCopy : <Image.Configuration> {
								'@translations' : {
									name : tr
								},
								URL :             'https://s3-eu-west-1.amazonaws.com/emergatev4/cl/STAODAZNIS/a/E3GC4QDIZW/assets/link.svg'
							}
						}
					}
				}
			},
			logoConfirmation :    <Image.Configuration> {
				URL :             'https://s3-eu-west-1.amazonaws.com/emergatev4/cl/STAODAZNIS/a/E3GC4QDIZW/assets/UI-Icons-Right.svg',
				'@translations' : {
					name : {
						'en' : 'Logo Confirmation',
						'fr' : 'Logo Confirmation'
					}
				}
			}
		};
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({});
	};
};
export namespace NS {
	export type Component = ReplayLinkModalComponent;
	export const Component = ReplayLinkModalComponent;
	export type Configuration = IReplayLinkModalComponentConfiguration;
}
import './ProductReplayLinkModal.scss';
import manifestXMLSource            from './ProductReplayLinkModal.xml';

CM.declare({
	id :       'product-replayLinkModal',
	type :     ReplayLinkModalComponent,
	manifest : manifestXMLSource
});
